export default __webpack_public_path__ + "static/media/project-3.2848bbd5.PNG";